import React, { useEffect, useState } from 'react';
import QuarterlyPerformance from '../components/QuarterlyPerformance';
import AssetBreakdownTwo from '../components/AssetBreakdownTwo';
import ChainSplit from '../components/ChainSplit';
import AssetBreakdown from '../components/AssetBreakdown';
import {
  defiWalletDetailSelector,
  getWalletDetail,
  getWalletDefiChain,
  getQuarterlyPerformance,
} from '../../../store/defi/walletDetailSlice';
import { useDispatch, useSelector } from 'react-redux';

const Overview = ({ account }) => {
  const dispatch = useDispatch();

  // const [_transactions, setTransaction] = useState([]);
  // const [_tokenDictionary, setTokenDictionary] = useState({});
  const [quarterlyPerformance, setQuarterlyPerformance] = useState();
  const [tokenChainBreakdown, setTokenChainBreakdown] = useState();
  const [chainTotalAmounts, setChainTotalAmounts] = useState();
  const [chainAssetBreakdown, setChainAssetBreakdown] = useState();

  const {
    quarterly_performance,
    transactions,
    chain_asset_breakdown,
    token_chain_breakdown,
    chain_total_amounts,
    performance_summary,
    tokenDictionary,
    available_chains,
  } = useSelector(defiWalletDetailSelector);

  useEffect(() => {
    if (account) {
      dispatch(getWalletDetail(account));
      dispatch(getWalletDefiChain({ account }));
      dispatch(getQuarterlyPerformance({ account }));
    }
  }, [account, dispatch]);

  useEffect(() => {
    // setTransaction(transactions);
    // setTokenDictionary(tokenDictionary);
    setQuarterlyPerformance(quarterly_performance);
    setTokenChainBreakdown(token_chain_breakdown);
    setChainTotalAmounts(chain_total_amounts);
    setChainAssetBreakdown(chain_asset_breakdown);
  }, [
    // transactions,
    // tokenDictionary,
    quarterly_performance,
    chain_total_amounts,
    chain_asset_breakdown,
    token_chain_breakdown,
  ]);

  return (
    <div className="overview" style={{ paddingBottom: '12rem' }}>
      <div className="" style={{ display: 'flex', gap: '0.8%' }}>
        <div className="" style={{ width: '66%' }}>
          <QuarterlyPerformance
            data={quarterlyPerformance}
            performance_summary={performance_summary}
          />
        </div>
        <div className="" style={{ flexGrow: 1, overflowX: 'hidden' }}>
          <ChainSplit chain_total_amounts={chainTotalAmounts} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: '0.8%' }}>
        <div className="" style={{ width: '66%' }}>
          <AssetBreakdown
            chain_asset_breakdown={tokenChainBreakdown}
            available_chains={available_chains}
          />
        </div>
        <div className="" style={{ flexGrow: 1, overflowX: 'hidden' }}>
          <AssetBreakdownTwo chain_asset_breakdown={chainAssetBreakdown} />
        </div>
      </div>
    </div>
  );
};

export default Overview;
